import React, { useState } from "react";
import HeaderThree from "../../../components/header/HeaderThree";
import { Helmet } from "react-helmet";

import mobileapp from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Mobile-App-Development.svg";
import game from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Game-app-development.svg";
import iphone from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Iphone-app-development.svg";
import android from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Android-app-development.svg";
import cross from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Cross-platform-mobile-app.svg";
import wearable from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Wearable-app-development.svg";
import enterprise from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Enterprise-solution.svg";
import webapp from "../../../assets/Mobile-app/Integrating-Innovative-Methods/Web-app-development.svg";
import InnovativeSuccess from "../../../assets/Sub-component/InnovativeSuccess";
import CoreComponent8 from "../../../assets/Sub-component/CoreComponent8";

import driven from "../../../assets/Android-app-dev/Our-agile-dev/Fixed-eng.svg";
import hour from "../../../assets/Android-app-dev/Our-agile-dev/Hourly-eng.svg";
import hires from "../../../assets/Android-app-dev/Our-agile-dev/Hire.svg";
import CoreComponent16 from "../../../assets/Sub-component/CoreComponent16";

import compat from "../../../assets/Android-app-dev/Why-invest-in-android/Compatibility.svg";
import cost from "../../../assets/Android-app-dev/Why-invest-in-android/cost-effective-development.svg";
import devfrnd from "../../../assets/Android-app-dev/Why-invest-in-android/developer-fnd.svg";
import flex from "../../../assets/Android-app-dev/Why-invest-in-android/Flexibility.svg";
import install from "../../../assets/Android-app-dev/Why-invest-in-android/Install.svg";
import quick from "../../../assets/Android-app-dev/Why-invest-in-android/Quick-Dep.svg";
import roi from "../../../assets/Android-app-dev/Why-invest-in-android/ROI.svg";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import CoreComponent9 from "../../../assets/Sub-component/CoreComponent9";
import Banner from "../../../assets/Sub-component/Banner";

import infograph from "../../../assets/Mobile-app/Infograph.svg";
import { Link } from "react-router-dom";
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import launchingimage from '../../../assets/Launchingimage.png'

const MobileAppDevelopers = () => {
   const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const banner = [
    {
      title: "Curious about what it's like to work here?",
      desc: "A group of skilled developers has been brought together to maximize the efficiency of your business, so prepare to release an application.",
      title2: "Curious about what it's like to work here?",
    },
  ];

  const service = [
    {
      icon: mobileapp,
      title: "Top-Tier Expertise",
      desc: "Gain immediate access to pre-screened, highly qualified developers for cross-platform, wearable, web, gaming, iOS, Android, and enterprise solutions. Modern talent without the hassle of hiring.",
      icon2: webapp,
      title2: "Cost & Time Savings",
      desc2:
        "Decrease overhead considerably. Our streamlined procedures and skilled teams shorten time-to-market, saving you money on hiring, payroll, and office supplies.",
    },
    {
      icon: game,
      title: "Flexible Scaling",
      desc: "Your development resources can be readily scaled up or down as your project progresses. We adjust to your needs and maximize efficiency whether you have a single expert or a whole team.",
      icon2: enterprise,
      title2: "Higher Quality",
      desc2:
        "Our rigorous adherence to industry best practices minimize project risks. We deliver advanced, secure, and high-quality applications that exceed expectations.",
    },
    {
      icon: iphone,
      title: "Focus on Your Core",
      desc: "Technical details are our responsibility. Make time for your internal team to focus on customer engagement, strategic growth, and your company's core competencies.",
      icon2: wearable,
      title2: "Transparent Process",
      desc2:
        "Gain access to clear communication, regular updates, and comprehensive project status information from committed project managers.",
    },
    {
      icon: android,
      title: "Android App Development",
      desc: "Our developers create powerful and versatile apps for your mobile. Our apps are compatible with the world's largest mobile user base and are scalable and high-performing.",
      icon2: cross,
      title2: "Cross-platform mobile app",
      desc2:
        "Our mobile app developers create apps with a single codebase that run smoothly on iOS and Android devices. We deliver efficient, cost-effective apps for consistent user experience and faster market entry.",
    },
  ];

  const corecontent = [
    {
      title: "Our Core Beliefs in Agile Development",
      desc: "Our approach for Mobile App Development focuses on rapid, user-centric development. Through our mobile app developers with engaging user experiences and significant business impact, this guarantees that your vision reaches the market as soon as possible.",
      icons: [
        {
          icon: driven,
          icontitle: "Cross-Platform Mobile App Development",
          icondesc:
            "Extensive knowledge of the top frameworks that enable the effective creation of apps for iOS and Android. This ensures consistent user experiences and faster deployment.",
        },
        {
          icon: hour,
          icontitle: "Web App Development",
          icondesc:
            "Strong command of both front-end and back-end technologies. They build reliable, and secure web applications with intuitive user experiences.",
        },
        {
          icon: hires,
          icontitle: "Game App Development",
          icondesc:
            "We are skilled in designing, animating, monetizing, and conceptualizing immersive and captivating gaming experiences.",
        },
      ],
    },
  ];

  const content100 = [
    {
      icon: compat,
      title: "Cost-Effective Development",
      desc: "Our efficient procedures deliver a high-quality product without a premium cost , providing an app that fits your budget.",
    },
    {
      icon: cost,
      title: "Built for Scalability",
      desc: "As your business grows, your app will be designed to accommodate new features, increased user numbers, and shifting consumer needs.",
    },
    {
      icon: devfrnd,
      title: "Broad Compatibility",
      desc: "Compatibility is our top priority ; your app will function flawlessly across various screens, and devices ensuring a consistent user experience.",
    },
  ];

  const content2 = [
    {
      icon: flex,
      title: "Empowering Innovation",
      desc: "Our developer-friendly methodology results in faster iterations, more creative and polished final products, and more efficient workflows.  ",
    },
    {
      icon: install,
      title: "Effortless User Onboarding",
      desc: "A simple download and installation process will encourage more people to use your product or service immediately.",
    },
    {
      icon: quick,
      title: "Rapid  Deployment",
      desc: "Our rapid deployment strategy ensures your app reaches the market. This agility enables you to seize opportunities, gain markets and see results faster.",
    },
    {
      icon: roi,
      title: "High Return on Investment (ROI)",
      desc: "Our strategic Android development maximizes a client's investment and ensures significant and sustained financial growth by leveraging broad market reach and effective monetization strategies..",
    },
  ];
   const handleClick=(e)=>{
    console.log(form)
    console.log("data submitted successfully")
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   
  
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <>
    <img className="Bg-image"
  src={launchingimage} 
  alt="Launching"
/>
    <div className="">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />
      <div
        className=" d-flex align-items-center justify-content-center flex-column "
        style={{ minHeight: "100vh" }}
      >
        <h1 className="h1-heading lh-sm fw-bold text-center">
          Mobile App Developers
        </h1>
        <p className="h1-para lh-base  text-center mt-4 mb-4">
          Raiden proactively delivers powerful, intuitive solutions with
          efficient mobile app developers, creating a truly expert mobile
          presence.
        </p>
        <Link to="/request-quote">
          {" "}
          
          <button className="h1-para mt-3 py-3 px-4  btn-gradient border-0 text-white rounded-4">
            Get Your Free Quote
          </button>
        </Link>
      </div>

      <div className="container">
        <div className="row  pb-80 padb d-flex align-items-center">
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base fw-semibold  mb-3">
              Experience the proficiency with Raiden’s Developers
            </h2>
            <p className=" h1-para lh-base me-5 mb-3 ">
              Raiden boasts a team of 40+ dedicated mobile app developers, each
              with 5+ years of experience in crafting high-performance,
              intuitive solutions. Our developers are adept at building
              applications that deliver a seamless and impactful reach across
              all devices, ensuring 100% client satisfaction and an impressive
              400% ROI for your mobile ventures.
            </p>
          </div>
          <div className="col-lg-6 col-11 mx-auto">
            <form onSubmit={handleClick}
              action=""
              className=" border border-2 rounded-4 p-4  h-100 row"
              style={{ width: "" }}
            >
              <h2 className="fw-semibold mb-md-4 mb-2 h2-heading text-start lh-base">
                Hire Raiden: Your App Development Edge
              </h2>
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  placeholder="Name"
                  className="px-2 py-0 "
                  style={{ width: "100%" }}
                   value={form.name}
                  onChange={(e)=>setForm({...form,name:e.target.value})}
                />
              </div>
              <div className="col-md-6 mb-3">
                <input
                  type="number"
                  placeholder="Mobile No."
                  className="px-2 py-0"
                  style={{ width: "100%" }}
                   value={form.mobile}
                  onChange={(e)=>setForm({...form,mobile:e.target.value})}
                />
              </div>
              <div className="col-12 w-100 mb-3">
                <input
                  type="email"
                  placeholder="Email Address"
                  className="px-2 py-1 w-100"  value={form.email}
                  onChange={(e)=>setForm({...form,email:e.target.value})}
                />
              </div>
              <div className="w-100 mb-3">
                <textarea
                  name=""
                  id=""
                  placeholder="What's your project about"
                  className="w-100 px-2 py-1 rounded-1"
                   value={form.message}
                  onChange={(e)=>setForm({...form,message:e.target.value})}
                ></textarea>
              </div>
              <div className="col-12">
                <button className="h1-para text-white text-center  btn-gradient rounded-3 text-white px-4 py-2">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* <!-----Cognitive Integrated  ------> */}
      <div className="pt-60 padt padb pb-60 bg-black overflow-hidden">
        <h2 className="h2-heading lh-base px-1 text-center text-white mb-35">
          Integrating Innovative Methods for Your Success
        </h2>
        <InnovativeSuccess service={service} />
      </div>

      <div className=" container mt-80 mart text-center">
        <h2 className="h2-heading lh-base">Our Agile Development Strategy</h2>
        <img
          src={infograph}
          style={{ width: "80%" }}
          alt=""
          className="mb-4 mt-3 pt-2"
        />
         <Link to="/request-quote">
        <button className="h1-para lh-base btn-gradient text-white px-4 py-2 rounded-2 m-auto ">
          Know More
        </button>
         </Link>
      </div>

      <div className="container text-center mt-80 mart">
        <h2 className=" h2-heading lh-base">Partnering for Wearable Success</h2>
        <p className="my-3  h3-para lh-base">
          Embark on your mobile application maintenance and support journey with
          Raiden as your steadfast partner
        </p>
        <CoreComponent9 />
      </div>

      <div className="container mt-80 mart">
        <CoreComponent8 corecontent={corecontent} />
      </div>

      <div className="container mt-80 mart ">
        <h2 className="h2-heading lh-base text-center mb-3">
          Achieving Android Excellence with Raiden
        </h2>
        <p className="h1-para lh-base text-center mb-2">
          Investing in an Android app with Raiden offers a strategic advantage,
          allowing your app to reach millions of users within the dominated
          global market
        </p>

        <CoreComponent16 content={content100} content2={content2} />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="border-y-div m-0">
        <Banner banner={banner} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default MobileAppDevelopers;
